import { TableService } from './table-service';
import { Package } from '../../../models/package';
import { PackageQuery } from '../../../models/package-query';
import { Observable, of } from 'rxjs';
import { EntityEnum } from '../../../enum/entity.enum';
import { Sort } from '@angular/material/sort';
import {
    selectPackageTableBusy, selectPackageTableCount,
    selectPackageTablePage,
    selectPackageTableQuery,
    selectPackageTableSelection
} from '../../../store/package-table/package-table.state';
import { PackageColumnEnum } from '../../../enum/package-column.enum';
import {
    packageTableChangePage,
    packageTableMasterToggle,
    packageTableSort,
    packageTableToggle
} from '../../../store/package-table/package-table.actions';
import { Injectable } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';

@Injectable({ providedIn: 'root' })
export class PackageTableService extends TableService<Package, PackageQuery> {

    protected getBusyObservable(): Observable<boolean> {
        return this.store.select(selectPackageTableBusy);
    }

    protected getColumnSelectionObservable(): Observable<string[]> {
        return of([
            'select',
            PackageColumnEnum.PACKAGE_DESCRIPTION,
            PackageColumnEnum.PACKAGE_WEIGHT,
            PackageColumnEnum.PACKAGE_DIMS,
            PackageColumnEnum.PACKAGE_INSURANCE,
            PackageColumnEnum.PACKAGE_TYPE,
            'actions'
        ]);
    }

    protected getCurrentPageEntriesObservable(): Observable<Package[]> {
        return this.store.select(selectPackageTablePage);
    }

    protected getEntity(): EntityEnum {
        return EntityEnum.PACKAGE;
    }

    protected getSelectionObservable(): Observable<string[]> {
        return this.store.select(selectPackageTableSelection);
    }

    protected getTableQueryObservable(): Observable<PackageQuery> {
        return this.store.select(selectPackageTableQuery);
    }

    protected getTotalCountObservable(): Observable<number> {
        return this.store.select(selectPackageTableCount);
    }

    pageChange(page: PageEvent): void {
        this.store.dispatch(packageTableChangePage({ pageNumber: page.pageIndex + 1, itemsPerPage: page.pageSize }));
    }

    sortChange(sort: Sort): void {
        this.store.dispatch(packageTableSort({ id: sort.active, descending: sort.direction === 'desc' }));
    }

    toggle(id: string): void {
        this.store.dispatch(packageTableToggle({ id }));
    }

    toggleAll(): void {
        this.store.dispatch(packageTableMasterToggle());
    }

    protected getWidthBufferPx(): number {
        return super.getWidthBufferPx() + 150;
    }

}
